import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import GuardPermissions from "./guards/GuardPermissions";
import Login from "./pages/Login";
import AuthGuard from "./guards/AuthGuard";
import HomeAdministrador from "./pages/Administrador/HomeAdministrador";
import PageNotFound from "./pages/404";
import Preregistro from "./pages/Preregistro";
import Turno from "./pages/Turnos";
import SignosVitales from "./pages/SignosVitales";
import Triage from "./pages/Triage";
import Medico from "./pages/Medico";
import Especialidades from "./pages/Administrador/Especialidades/Especialidades";
import Municipios from "./pages/Administrador/Municipios/Municipios";
import Usuarios from "./pages/Administrador/Usuarios/Usuarios";
import TurnosAdminSignos from "./pages/AdminTurnosSignos";
import TurnosAdminTriage from "./pages/TurnosAdminTriage";
import HomeEstadisticas from "./pages/HomeEstadisticas";


export default function Router() {
  return (
    <BrowserRouter>
      <GuardPermissions>
        <Routes>
          <Route element={<AuthGuard />}>
            <Route path="/Administrador" element={<HomeAdministrador />} />
            <Route path="/Administrador/especialidades" element={<Especialidades />} />
            <Route path="/Administrador/municipios" element={<Municipios />} />
            <Route path="/Administrador/usuarios" element={<Usuarios />} />
            <Route path="/Preregistro" element={<Preregistro />} />
            <Route path="/SignosVitales" element={<SignosVitales />} />
            <Route path="/Triage" element={<Triage />} />
            <Route path="/Medico" element={<Medico />} />
            <Route path="/TurnosAdminSignos" element={<TurnosAdminSignos />} />
            <Route path="/TurnosAdminTriage" element={<TurnosAdminTriage />} />
            <Route path="/AdminEstadisticas" element={<HomeEstadisticas />} />
          </Route>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/turnos" element={<Turno />} />
          <Route path="/unauthorized" element={<div>No tienes permiso para acceder a esta página.</div>} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </GuardPermissions>
    </BrowserRouter>
  );
}